/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-09-29 10:33:30
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Stack } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import IconNoResult from 'src/assets/images/recommendation/empty-results.svg';

type Props = WithI18nProps & {};

class NoRecommendation extends Component<Props> {
  render() {
    const { i18n } = this.props;
    return (
      <div className="BC-Page__ManualType__NoRecommendation">
        <Stack vertical alignment="center" distribution="center">
          <img
            src={IconNoResult}
            alt={i18n.translate('AdminHTML.Recommendation.ManualRecommendation.ManualType.noRecommendation')}
          />
          <p>{i18n.translate('AdminHTML.Recommendation.ManualRecommendation.ManualType.noRecommendation')}</p>
        </Stack>
      </div>
    );
  }
}

export default withI18n()(NoRecommendation);
